import React from 'react';
import { defaultTheme } from './../../styles/theme/default';
import { IIcon } from './../../@types/icons';

export function Like ({ strokeColor, fillColor }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={fillColor ? defaultTheme.colors[fillColor] || fillColor : 'none'}
      viewBox="0 0 16 16"
    >
      <path
        stroke={
          strokeColor
            ? defaultTheme.colors[strokeColor] || strokeColor
            : defaultTheme.colors.dimGray
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 6.5l3.025-5.156c.116-.182.28-.331.475-.434.195-.103.415-.157.638-.154.176-.006.35.021.515.08.164.06.314.151.441.267.127.116.228.255.298.41.07.153.107.32.108.487v4.5l4.682.038c.192.006.381.05.554.131.172.08.325.195.448.336a1.245 1.245 0 01.3 1.026l-.946 6.338c-.04.312-.199.599-.446.807a1.387 1.387 0 01-.893.324H4M1.023 6.5H4v9H1.023a.481.481 0 01-.37-.186.708.708 0 01-.153-.448V7.134c0-.168.055-.33.153-.448a.481.481 0 01.37-.186z"
      />
    </svg>
  );
}
